import { render, staticRenderFns } from "./Recommender.vue?vue&type=template&id=8f6f3f60&scoped=true"
import script from "./Recommender.vue?vue&type=script&lang=js"
export * from "./Recommender.vue?vue&type=script&lang=js"
import style0 from "./Recommender.vue?vue&type=style&index=0&id=8f6f3f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6f3f60",
  null
  
)

export default component.exports